/**
 * toast — singleton emitter. Can be called from anywhere (service layer,
 * event handler, error boundary) without needing React context.
 *
 *   import { toast } from 'components/ui';
 *   toast.success('Partenaire créé');
 *   toast.error('Échec de la sauvegarde', { description: err.message });
 *
 * The <ToastProvider /> in App.js subscribes and renders the UI.
 */
const listeners = new Set();
let nextId = 0;

function emit(t) {
  listeners.forEach((cb) => cb(t));
  return t.id;
}

function build(partial) {
  const defaults = { id: ++nextId, variant: 'info', duration: 4000 };
  const merged =
    typeof partial === 'string' ? { ...defaults, title: partial } : { ...defaults, ...partial };
  if (!('duration' in (typeof partial === 'object' ? partial : {}))) {
    if (merged.variant === 'danger' || merged.variant === 'warning') merged.duration = 6000;
  }
  return merged;
}

export const toast = {
  show(input) {
    return emit(build(input));
  },
  success(title, opts) {
    return emit(build({ variant: 'success', title, ...opts }));
  },
  error(title, opts) {
    return emit(build({ variant: 'danger', title, ...opts }));
  },
  warning(title, opts) {
    return emit(build({ variant: 'warning', title, ...opts }));
  },
  info(title, opts) {
    return emit(build({ variant: 'info', title, ...opts }));
  },
  dismiss(id) {
    listeners.forEach((cb) => cb({ __dismiss: true, id }));
  },
  /** internal — do not use from app code */
  _subscribe(cb) {
    listeners.add(cb);
    return () => listeners.delete(cb);
  },
};

export default toast;
